import { Injectable } from '@angular/core';
@Injectable()
export class RouteLoggerService {
}



// WEBPACK FOOTER //
// ./src/app/shared/route-logger.service.ts